// Lib imports
import axios from 'axios'
import type { App } from 'vue'

// Vue 3 port of `Vue.prototype.$http = axios`: exposed as a plugin so main.ts
// can app.use() it. Shares the global interceptors (session id header).
export default {
  install(app: App) {
    app.config.globalProperties.$http = axios
  },
}
